import React from "react";
import { Button, Input } from "antd";

export default function DynamicListInput({
  title,
  value = [],
  onChange,
  placeholder,
}) {
  const addItem = () => {
    onChange([...(value || []), ""]);
  };

  const removeItem = (index) => {
    onChange(value.filter((_, i) => i !== index));
  };

  const updateItem = (index, val) => {
    const copy = [...value];
    copy[index] = val;
    onChange(copy);
  };

  return (
    <div
      style={{
        border: "1px solid #f0f0f0",
        borderRadius: 8,
        padding: 12,
        marginBottom: 16,
      }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <strong>{title}</strong>

        <Button size="small" type="primary" onClick={addItem}>
          + Нэмэх
        </Button>
      </div>

      {(value || []).map((item, index) => (
        <div key={index} className="d-flex gap-2 mb-2">
          <Input
            value={item}
            placeholder={placeholder}
            onChange={(e) => updateItem(index, e.target.value)}
          />

          <Button danger onClick={() => removeItem(index)}>
            Устгах
          </Button>
        </div>
      ))}
    </div>
  );
}
